// Which breast a breast cancer was in (TGCLOUD-1910). The triage rule packs
// need it: NICE CG164 counts a bilateral breast cancer as two relatives, and
// several criteria name "bilateral breast cancer" with the age of the first
// primary. Recorded on the diagnosis as `laterality`, with the age at the
// second primary as `contralateralAge` (backend/models/diagnoses-schema.js),
// and read by backend/services/triage/cancerClasses.js.
//
// Offered for a breast diagnosis while triage is on for the group, and on any
// diagnosis that already holds a laterality, so a recorded value can always be
// seen and changed.
export const LATERALITY_OPTIONS = Object.freeze([
  { value: 'left', label: 'Left' },
  { value: 'right', label: 'Right' },
  { value: 'bilateral', label: 'Both (bilateral)' },
  { value: 'unknown', label: 'Not known' }
]);

const BREAST = /\b(breast|mammary)\b/i;

export const offersLaterality = (diagnosis, { triageOn } = {}) =>
  Boolean(diagnosis?.laterality) ||
  (triageOn === true && BREAST.test(String(diagnosis?.name || '')));
